<div class="modal-header">
  <h5 class="modal-title">This submission is not complete</h5>
  <button type="button" class="btn-close" aria-label="Close"
          (click)="modal.dismiss()"></button>
</div>

<div class="modal-body">
  <p class="sv-intro">
    <ng-container *ngIf="lot">{{ lotOrHipText }} {{ lot }}<span *ngIf="horseName"> &middot; {{ horseName }}</span> —
    </ng-container>
    the following {{ issues.length === 1 ? 'item needs' : issues.length + ' items need' }}
    attention before these files can be submitted.
  </p>

  <ul class="sv-list">
    <li class="sv-item" *ngFor="let issue of issues; let i = index">
      <div class="sv-item__head">
        <span class="sv-item__num">{{ i + 1 }}</span>
        <span class="sv-item__title">{{ issue.title }}</span>
      </div>

      <ul class="sv-detail" *ngIf="issue.details?.length">
        <li class="sv-detail__row" *ngFor="let detail of issue.details">
          {{ detail }}
        </li>
      </ul>
    </li>
  </ul>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="modal.close()">
    Back to upload
  </button>
</div>
